function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 12L8 14L13.9146 14C13.9699 13.8436 14 13.6753 14 13.5V12.5C14 12.3247 13.9699 12.1564 13.9146 12L8 12ZM0 12.5C0 12.3247 0.0300774 12.1564 0.0853537 12H3L3 14H0.085352C0.0300768 13.8436 0 13.6753 0 13.5V12.5ZM4 14L4 12H7L7 14H4ZM8 8L13.9146 8C13.9699 7.84361 14 7.67532 14 7.5V6.5C14 6.32468 13.9699 6.15639 13.9146 6L8 6V8ZM7 8V6H4V8H7ZM3 8V6L0.0853538 6C0.0300775 6.15639 0 6.32468 0 6.5V7.5C0 7.67532 0.0300768 7.84361 0.0853519 8L3 8ZM4 2L7 2L7 0H4L4 2ZM8 0L8 2L13.9146 2C13.9699 1.84361 14 1.67532 14 1.5V0.500001C14 0.324683 13.9699 0.15639 13.9146 0H8ZM3 0L3 2L0.0853519 2C0.0300768 1.84361 0 1.67532 0 1.5V0.500001C0 0.324683 0.0300773 0.15639 0.0853533 0H3ZM3 3V3L1.4972 3L1.5 3H3Z",
  fill: "#3E5C69"
});

function SvgListWidgetType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListWidgetType);
export default __webpack_public_path__ + "static/media/list_widget_type.9aff46f7.svg";
export { ForwardRef as ReactComponent };